module.exports = __webpack_public_path__ + "static/media/DXchange-iPaaS.c987db78.png";